import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import {
  woodProductMap,
  WoodPropertyName,
  Plywood,
  WoodType,
} from './wood.model';
import {
  DEFAULT_AREAL_DENSITY_PROPERTIES,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
  IConditionalNode,
} from '../../../helpers/conditional-nodes.helpers';
import { ProductID } from '../../../models/product.model';
import { woodProperties } from './wood-properties';

const woodTypeProductMap = Object.fromEntries(
  (Object.values(WoodType) as WoodType[])
    .filter((type) => type !== WoodType.Plywood)
    .map((type) => [type, woodProductMap[type]]),
) as Record<Exclude<WoodType, WoodType.Plywood>, ProductID>;

export const woodProductIds: IConditionalNode<ProductID> = {
  property: WoodPropertyName.WoodType,
  map: {
    ...woodTypeProductMap,
    [WoodType.Plywood]: {
      property: WoodPropertyName.PhenolCoated,
      map: {
        true: woodProductMap[Plywood.PhenolCoated],
        false: woodProductMap[Plywood.General],
      },
    },
  },
};

export const wood: IElementCategory = {
  id: ElementCategoryID.Wood,
  name: 'Wood',
  color: '#A4AE93',
  defaultSelectedQuantity: 'mass',
  properties: woodProperties,
  getQuantityProperties: () => ({
    ...DEFAULT_QUANTITY_PROPERTIES,
    ...DEFAULT_AREAL_DENSITY_PROPERTIES,
  }),
  // `throwIfNotFound: false` + `undefined` passthrough: wood has a nested
  // conditional (WoodType→PhenolCoated for Plywood), so transient
  // inconsistent combos can miss the tree. `undefined` lets the caller skip
  // enrichment and keep existing children (see metal.ts comment).
  getChildElements: (element) =>
    getValueFromConditionalNodes(element, [woodProductIds], false),
  getElementPropertySelectionByProductId: (id) =>
    getElementPropertySelectionByValue(id, woodProductIds),
};
